import {IContactForms, IIconCards} from "../initState/InterfacesState";

export enum IWordpressArticleLocation {
  main = 'main',
  popular = 'popular'
}

export interface IWordpressArticle {
  blog_size: number;
  blog_type: 'news' | 'blog' | 'stretchy';
  content_text: string;
  date: string;
  id: string;
  image: string | null;
  image_fullwidth: string | null;
  alias: string;
  title: string;
  title_seo: string;
  description_seo: string;
  keywords_seo: string;
  uri: string;
  location?: IWordpressArticleLocation[]
}

export interface IWordpressBlog {
  articles: IWordpressArticle[];
}

export interface IWordpressAll {
  main: {
    title: string;
    small_title: string;
    title_get_guide: string;
    title_p: string;
    small_title_p: string;
    advantages: { text: string; template: string }[];
  },
  company: {},
  blog: {
    articles: IWordpressArticle[]
  },
  company_logos: {
    items: IWordpressCompanyLogo[]
  },
  advantage_slider: {
    slides: IWordpressCarouselSlide[]
  },
  reviews: {
    items: IWordpressReview[]
  },
  vacancies: {
    image: string;
    title: string;
    subtitle: string;
    form_caption: string;
    items: IWordpressVacancy[];
  },
  stories: {
    items: IWordpressStory[]
  },
  text_cards: {
    title: string;
    items: {text: string}[]
  },
  icon_cards: IIconCards,
  contact_forms: IContactForms,
}

export enum IWordpressStorySlideType {
  image = 'image',
  video = 'video'
}

export interface IWordpressStorySlide {
  name: string;
  url: string;
  type: IWordpressStorySlideType
}

export interface IWordpressStory {
  title: string;
  image: string;
  slides: IWordpressStorySlide[]
}

export interface IWordpressVacancyInfo {
  title: string;
  text: string;
}

export interface IWordpressVacancy {
  id: string;
  title: string;
  salary: string | null;
  image: string | null;
  group: string;
  info: IWordpressVacancyInfo[];
}

export interface IWordpressVacancyGroup {
  category: string;
  items: IWordpressVacancy[];
}

export interface IWordpressCarouselSlide {
  image?: string;
  title: string;
  text: string;
}

export interface IWordpressCompanyLogo {
  image: string;
  alt: string;
}

export interface IWordpressReview {
  text: string;
  author: string;
  company: string;
  site: string;
}

export interface IWordpressTracking {
  errormsg?: string;
  tracking?: {
    company: string;
    date: string;
    invoice: string;
    number: string;
    statushistory: {
      status: {
        eventtime: string;
        office: string;
        title: string;
      }[];
    };
    town: string;
  }
}

export interface IWordpressSimple {
  content: string;
}
